import React from 'react';
const Loading = ({ isLoading }) => (
    <div>
        <style jsx="true">
            {`
                .overlay {
                    position: fixed;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 9999;
                }
                .lds-ring {
                    display: inline-block;
                    position: relative;
                    width: 64px;
                    height: 64px;
                  }
                  .lds-ring div {
                    box-sizing: border-box;
                    display: block;
                    position: absolute;
                    width: 51px;
                    height: 51px;
                    margin: 6px;
                    border: 6px solid #47c0bb;
                    border-radius: 50%;
                    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
                    border-color: #47c0bb transparent transparent transparent;
                  }
                  .lds-ring div:nth-child(1) {
                    animation-delay: -0.45s;
                  }
                  .lds-ring div:nth-child(2) {
                    animation-delay: -0.3s;
                  }
                  .lds-ring div:nth-child(3) {
                    animation-delay: -0.15s;
                  }
                  @keyframes lds-ring {
                    0% {
                      transform: rotate(0deg);
                    }
                    100% {
                      transform: rotate(360deg);
                    }
                  }
            `}
        </style>
        {isLoading ?
            <div className="overlay" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
            </div>
        : null}
    </div>
)

export default Loading